import Form from "@/Form";
import Modal from "@/Modal";

import "./style.css";

export default class TalkToUsModal extends Modal {
  static selector = ".talk-to-us-modal";

  modalDidMount = async () => {
    this.formElement = this.modal.querySelector(".talk-to-us-modal__form");
    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleFormSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: true,
      gainControlOnSubmitSucceeded: false
    });

    // get contact and page fields
    this.contactField = this.modal.querySelector('input[name="contact"]');
    this.pageField = this.modal.querySelector('input[name="page"]');
  };
  modalWillOpen = async () => {
    this.form.reset();
    this.modal.classList.remove("talk-to-us-modal--success");
    this.pageField.value = window.location.href;
  };
  modalDidUpdate = async ({ contact = "", page = "" }) => {
    this.contactField.value = contact;
    this.pageField.value = page || window.location.href;
  };

  handleFormSubmitSucceeded = () => {
    window.location.href = "/thank-you-page-talk-to-us/";
  };
}
